import {
  setUserFolderData,
  setSharedFolderData,
  setSelectedFolder,
  setEditFolderData,
  setDeletedFolderData,
  setNewOrder,
  updateFolderName,
  createEditFolder,
  setSelectedPermissionTeam,
  addPermissionTeam,
  setPermissionTeams,
  addPermissionUser,
  setPermissionUsers,
  removeEntityFromSelection,
  sortValues,
  getUserFolderData,
  setSelectedFolderData,
  uploadFolders,
  setPermissionVisible,
  setDepartmentVisible,
  setSharedByVisible,
  setEditFolderViewVisible,
  setPermissionSettingVisible,
  createTemplateData,
  fetchTemplateData,
  updateTemplateData,
  updateShareFolderData,
  deleteTemplate,
  fetchTemplates,
  queryByPaging,
  setSelectedTeam,
  setSelectedUser,
  setAllUser,
  getAllUser,
  updateFieldOption,
  fetchNewTemplateData,
  setPaginations
} from '../emailTemplates/flow/action';

import {
  fetchSelectedTemplateData,
  newEmailQueryByPaging,
  newEmailSetTemplatesData,
  newEmailResetTemplatesData,
  sendEmail,
  fetchUserEmail,
  resetSelectedTemplate
} from '../newEmail/flow/action';

export {
  setUserFolderData,
  setEditFolderData,
  setDeletedFolderData,
  updateFolderName,
  createEditFolder,
  setSelectedPermissionTeam,
  addPermissionTeam,
  addPermissionUser,
  removeEntityFromSelection,
  sortValues,
  getUserFolderData,
  setSelectedFolderData,
  uploadFolders,
  setPermissionVisible,
  setDepartmentVisible,
  setSharedByVisible,
  setEditFolderViewVisible,
  setPermissionSettingVisible,
  setPaginations,
  createTemplateData,
  fetchTemplateData,
  updateTemplateData,
  updateShareFolderData,
  deleteTemplate,
  fetchTemplates,
  queryByPaging,
  setSelectedTeam,
  setSelectedUser,
  setAllUser,
  getAllUser,
  updateFieldOption,
  fetchNewTemplateData,
  fetchSelectedTemplateData,
  newEmailQueryByPaging,
  newEmailSetTemplatesData,
  newEmailResetTemplatesData,
  sendEmail,
  fetchUserEmail,
  resetSelectedTemplate
};



// WEBPACK FOOTER //
// ./src/views/email/flow/action.js